/** @format */

import React from "react";
import ReactMarkdown from "react-markdown";

interface IProps {
	termsOfServiceText?: string;
}

const TermsOfServiceView: React.FC<IProps> = ({ termsOfServiceText }) => (
	<ReactMarkdown>{termsOfServiceText || ""}</ReactMarkdown>
);

export default TermsOfServiceView;
